const userDataRoutePrefixes = ['/dashboard', '/home', '/settings'] as const;

const shouldPreloadUserDataOnPath = (pathname: string) =>
  userDataRoutePrefixes.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`));

export { shouldPreloadUserDataOnPath };
